import React from "react";
import ListEditor from "../ListEditor";
import { adminApi } from "../../lib/api";
import { Label, TextInput, TextArea, NumberInput, Switch, TagEditor, BulletEditor, ImageUploader, Select } from "../FormControls";

const newProject = () => ({
  title: "",
  subtitle: "",
  short_description: "",
  description: "",
  long_description: "",
  category: "Project",
  status: "Completed",
  technologies: [],
  tags: [],
  github_url: "",
  demo_url: "",
  video_url: "",
  image_url: "",
  thumbnail_url: "",
  screenshots: [],
  problem: "",
  solution: "",
  key_features: [],
  challenges: "",
  results: "",
  impact: [],
  start_date: "",
  end_date: "",
  year: new Date().getFullYear().toString(),
  accent: "cyan",
  featured: false,
  visible: true,
  order: 0,
});

const Projects = () => (
  <ListEditor
    resource={adminApi.projects}
    resourceKey="projects"
    title="Projects"
    description="Each project becomes an expandable case-study on the live site."
    newItem={newProject}
    canDuplicate
    searchFields={["title", "subtitle", "category"]}
    renderRow={(p) => (
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-9 h-9 rounded-lg bg-white/[0.04] border border-white/10 grid place-items-center text-cyan-300 font-display font-medium text-sm shrink-0">
          {p.title?.[0]?.toUpperCase() || "P"}
        </div>
        <div className="min-w-0">
          <div className="text-white font-medium truncate flex items-center gap-2">
            {p.title || "Untitled"}
            {p.featured && <span className="text-[10px] font-mono px-1.5 py-0.5 rounded-full border border-cyan-400/30 text-cyan-300">FEATURED</span>}
          </div>
          <div className="text-xs text-slate-500 truncate">
            {p.category} · {p.year || "—"} · {(p.technologies || []).slice(0, 4).join(", ")}
          </div>
        </div>
      </div>
    )}
    renderForm={(d, set) => (
      <>
        <div>
          <Label>Title</Label>
          <TextInput value={d.title} onChange={(v) => set("title", v)} placeholder="GitBot" />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Subtitle</Label>
            <TextInput value={d.subtitle} onChange={(v) => set("subtitle", v)} />
          </div>
          <div>
            <Label>Year</Label>
            <TextInput value={d.year} onChange={(v) => set("year", v)} placeholder="2025" />
          </div>
        </div>
        <div className="grid sm:grid-cols-3 gap-3">
          <div>
            <Label>Category</Label>
            <TextInput value={d.category} onChange={(v) => set("category", v)} />
          </div>
          <div>
            <Label>Status</Label>
            <Select value={d.status} onChange={(v) => set("status", v)} options={["Completed", "In Progress", "Archived"]} />
          </div>
          <div>
            <Label>Accent</Label>
            <Select value={d.accent} onChange={(v) => set("accent", v)} options={["cyan", "violet"]} />
          </div>
        </div>
        <div>
          <Label>Short description (shown on card)</Label>
          <TextArea value={d.short_description} onChange={(v) => set("short_description", v)} rows={2} />
        </div>
        <div>
          <Label>Long description (in modal)</Label>
          <TextArea value={d.long_description} onChange={(v) => set("long_description", v)} rows={5} />
        </div>
        <div>
          <Label>Impact / key bullets</Label>
          <BulletEditor value={d.impact} onChange={(v) => set("impact", v)} placeholder="Add impact point" />
        </div>
        <div>
          <Label>Technologies</Label>
          <TagEditor value={d.technologies} onChange={(v) => set("technologies", v)} placeholder="e.g. Spring Boot" />
        </div>
        <div>
          <Label>Tags</Label>
          <TagEditor value={d.tags} onChange={(v) => set("tags", v)} />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>GitHub URL</Label>
            <TextInput value={d.github_url} onChange={(v) => set("github_url", v)} placeholder="https://github.com/..." />
          </div>
          <div>
            <Label>Demo URL</Label>
            <TextInput value={d.demo_url} onChange={(v) => set("demo_url", v)} placeholder="https://..." />
          </div>
        </div>
        <div>
          <Label>Cover image</Label>
          <ImageUploader value={d.image_url} onChange={(v) => set("image_url", v)} />
        </div>
        <div className="flex items-center gap-6 pt-2">
          <Switch value={d.featured} onChange={(v) => set("featured", v)} label="Featured" />
          <Switch value={d.visible} onChange={(v) => set("visible", v)} label="Visible on site" />
        </div>
        <div>
          <Label>Display order</Label>
          <NumberInput value={d.order} onChange={(v) => set("order", v)} />
        </div>
      </>
    )}
  />
);

export default Projects;
